import { EmailTemplateTypes } from '../../../api/email-templates.dao';
import { DESCRIPTION as DESCRIPTION_TEXT, TYPE as TYPE_TEXT } from '../../../constants/common-labels.constants';
import { FormVmItemConfigType } from '../../../infrastructure/form-viewmodel-controller';
import { buildConfigList } from '../../../infrastructure/utils/form-config.utils';
import { trimSpaces, trimSpacesLeft } from '../../../modules/formatters';
import { emailList, plainText, richText } from '../../../modules/validators';
import { TEMPLATE_NAME } from '../../_email-templates/email-templates.text';
import { BCC_TEXT, CC_TEXT, REPLY_TO_TEXT, TO_TEXT } from '../../_events/_manage-event/_connections/_meeting-connections-form/send-connections-email-form/send-connections-email-form.texts';
import { EMAIL_BODY_TEXT, EMAIL_SUBJECT_TEXT } from '../../_events/_manage-event/_edit-website/website-form-body/scheduled-emails-form/scheduled-email-form/scheduled-email-form.texts';

export enum EmailTemplateFieldKey {
    NAME = 'name',
    TYPE = 'type',
    DESCRIPTION = 'description',
    TO = 'to',
    REPLY_TO = 'replyTo',
    CC = 'cc',
    BCC = 'bcc',
    EMAIL_SUBJECT = 'emailSubject',
    EMAIL_BODY = 'emailBody'
}

 const allowedRecipientsFieldsVariables = {
    projectManagerEmail: '{{Project_Manager_Email}}',
    coProjectManagerEmail: '{{Co_Project_Manager_Email}}',
    eventCoordinatorEmail: '{{Event_Coordinator_Email}}',
};

const recipientsFieldsValidator = (value: string) => {
    const allowedVariables = Object.values(allowedRecipientsFieldsVariables).join(',');

    return emailList.regExp(value, null, allowedVariables);
};

export const FORM_CONFIG = {
    [EmailTemplateFieldKey.NAME]: {
        labelDescriptor: TEMPLATE_NAME,
        defaultValue: '',
        validators: [plainText.required, plainText.maxLength.short],
        formatters: [trimSpacesLeft]
    },
    [EmailTemplateFieldKey.TYPE]: {
        labelDescriptor: TYPE_TEXT,
        defaultValue: EmailTemplateTypes.CONNECTION_EMAIL,
    },
    [EmailTemplateFieldKey.DESCRIPTION]: {
        labelDescriptor: DESCRIPTION_TEXT,
        defaultValue: '',
        validators: [plainText.maxLength.medium],
        formatters: [trimSpacesLeft]
    },
    [EmailTemplateFieldKey.TO]: {
        labelDescriptor: TO_TEXT,
        defaultValue: [],
        validators: [recipientsFieldsValidator],
        formatters: [trimSpaces]
    },
    [EmailTemplateFieldKey.REPLY_TO]: {
        labelDescriptor: REPLY_TO_TEXT,
        defaultValue: [],
        validators: [recipientsFieldsValidator],
        formatters: [trimSpaces]
    },
    [EmailTemplateFieldKey.CC]: {
        labelDescriptor: CC_TEXT,
        defaultValue: [],
        validators: [recipientsFieldsValidator],
        formatters: [trimSpaces]
    },
    [EmailTemplateFieldKey.BCC]: {
        labelDescriptor: BCC_TEXT,
        defaultValue: [],
        validators: [recipientsFieldsValidator],
        formatters: [trimSpaces]
    },
    [EmailTemplateFieldKey.EMAIL_SUBJECT]: {
        labelDescriptor: EMAIL_SUBJECT_TEXT,
        defaultValue: '',
        validators: [plainText.required, plainText.maxLength.short],
        formatters: [trimSpacesLeft]
    },
    [EmailTemplateFieldKey.EMAIL_BODY]: {
        labelDescriptor: EMAIL_BODY_TEXT,
        defaultValue: '',
        validators: [plainText.required, richText.maxLength.long],
        formatters: [trimSpacesLeft]
    },
};

export const configList: FormVmItemConfigType[] = buildConfigList(FORM_CONFIG);
